/**
 * Tenant-level freemium mode.
 *
 * Freemium mode is normally a property of the *stack* — the bundle served from
 * `app.myaltimate.com` — which is how `isFreeStack()` derives it, from the
 * hostname. A tenant migrated onto the enterprise stack keeps the freemium
 * product surface, so `freemiumModeEnabled` in tenant_info turns that surface
 * on for one tenant on any host (AI-7855).
 *
 * Held in module scope rather than React state so `isFreeStack()` keeps its
 * synchronous signature and its ~28 existing callers are untouched. Set once
 * from the tenant-info response: AppProvider gates its children behind a loader
 * until that fetch resolves, so no authenticated view can read the pre-fetch
 * value. Views that render BEFORE login — login, register, social callbacks,
 * instance finder — intentionally keep hostname-only behaviour, because
 * self-serve signup belongs to the freemium stack, not to a tenant.
 *
 * This lives in its own module, not in `helpers/tenant.ts`, because 10 test
 * files replace that module wholesale via `jest.mock` without spreading
 * `requireActual`. A new export there is `undefined` in each of them, which
 * breaks the setter call in `useAppActions` at runtime.
 */
let freemiumModeEnabled = false;

export const setFreemiumMode = (enabled: boolean): void => {
  freemiumModeEnabled = enabled;
};

export const isFreemiumModeEnabled = (): boolean => freemiumModeEnabled;
